var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-list',[(_vm.relation)?_c(_vm.relation.module + '_' + _vm.relation.type.code,{tag:"component",attrs:{"data":_vm.data,"currency":_vm.relation.currency_code}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }